<template>
    <div class="map-marker">
        <LVector :zIndex="10" v-if="layerAuto && layerAuto.hasArea && mapZoom > 13.3">
            <LCircleFeature v-for="item in hList" :obj="item" :center="[item.longitude, item.latitude]"
                :radius="Number(item.scope)" :key="item.id + '_circle'" :id="item.id + '_circle'" :defaultStyle="{
                    renderer:
                        hoverFeatureId === item.id + '_point' ? getRenderer(item, true) : getRenderer(item),
                }" />
        </LVector>

        <LVector v-if="statiMapHives.length > 0" :zIndex="11" :selectFeature="select">
            <template v-for="item in statiMapHives">
                <!-- v-if="dangerCoordinate.longitude && item.hasCheckedBox" -->
                <LOverLay
                    :position="[item.longitude, item.latitude]" :key="item.id + '_over'" :id="item.id + '_over'"
                    :autoPan="false" className="command-overlayer-hives-checkbox">
                    <!-- item.status ===true &&  -->
                    <el-checkbox
                        v-show="layerAuto && layerAuto.hasBhangar && layerAuto.hasEmergencyDanger"
                        v-model="item.checked" style="position: absolute; top: -20px"
                        :style="mapZoom > 14 ? 'left: 30px' : 'left: 22px'" @change="checkHive($event, item)"
                        fill="#000"></el-checkbox>
                </LOverLay>
            </template>
        </LVector>

        <LVector v-if="layerAuto.hasBhangar" :zIndex="12" :selectFeature="select" :hoverFeature="hoverFeature">
            <LPointFeature v-for="item in hList" :obj="item" :longitude="item.longitude" :latitude="item.latitude"
                :key="item.id + '_point'" :id="item.id + '_point'" :defaultStyle="hivetStyle(item.name, item)" />

            <LPointFeature v-for="item in hList" :obj="item" :longitude="item.longitude" :latitude="item.latitude"
                :key="item.id + '_title'" :id="item.id + '_title'" :defaultStyle="topStyle(item)">
                <div slot="labelOverlay" style="color: #ffffff; white-space: nowrap" :style="hiveLabelStyle(item)">
                    <div style="overflow: hidden">
                        <CustomMarquee :textLength="hiveLabel(item).length" :autoScroll="true"
                            :ref="item.id + '_Marquee'">
                            <p>
                                {{ hiveLabel(item) }}
                            </p>
                        </CustomMarquee>
                    </div>
                </div>
            </LPointFeature>
        </LVector>
        <LVector :zIndex="13" :selectFeature="select" v-if="
            layerAuto &&
            layerAuto.hasEmergencyDanger &&
            dangerCoordinate.longitude &&
            layerAuto.hasBhangar
        ">
            <!-- 连线 -->
            <template v-for="item in statiMapHives">
                <LLineFeature :pointData="[
                    [dangerCoordinate.longitude, dangerCoordinate.latitude],
                    [+item.longitude, +item.latitude],
                ]" v-if="item.hasCheckedBox" :key="item.id + '_epline'" :id="item.id + '_epline'" :defaultStyle="{
                    stroke: {
                        color: item.checked ? '#FFA115' : 'rgba(252, 255, 54, 0.94)',
                        width: 3,
                        lineDash: item.checked ? '' : [5, 10, 5, 10],
                    },
                }" />
            </template>

            <template v-for="item in statiMapHives">
                <LPointFeature :longitude="(+item.longitude + +dangerCoordinate.longitude) / 2"
                    :latitude="(+item.latitude + +dangerCoordinate.latitude) / 2" :key="item.id + '_km'" :id="item.id"
                    :obj="item" :overlayOffset="[0, 0]" className="command-overlayer-hives-km">
                    <div v-if="defaultCheckList.some((i) => i.id === item.id)" slot="labelOverlay"
                        class="point-distance-active" v-show="item.hasCheckedBox">
                        {{
                            {
                                ponit1: { latitude: +item.latitude, longitude: +item.longitude },
                                point2: {
                                    latitude: +dangerCoordinate.latitude,
                                    longitude: +dangerCoordinate.longitude,
                                },
                            } | getDistance
                        }}推荐
                    </div>
                    <div v-else slot="labelOverlay" class="point-distance" v-show="item.hasCheckedBox">
                        {{
                            {
                                ponit1: { latitude: +item.latitude, longitude: +item.longitude },
                                point2: {
                                    latitude: +dangerCoordinate.latitude,
                                    longitude: +dangerCoordinate.longitude,
                                },
                            } | getDistance
                        }}
                    </div>
                </LPointFeature>
            </template>
        </LVector>

        <!-- 机库弹窗 -->
        <el-popover placement="top" width="298px" trigger="click" v-model="visible"
            popper-class="is-no-padding is-no-arrow">
            <div class="c-hive-point__popover">
                <div class="c-hive-point__header">
                    {{ hiveObj.name }}
                </div>
                <div style="position: absolute; top: -20px; right: -20px; cursor: pointer" @click="visible = false">
                    <img :src="require('./images/icon_close.png')" alt="" />
                </div>
                <div class="c-hive-point__main">
                    <!-- 弹窗视频/图片 -->
                    <div>
                        <div class="c-hive-point__video">
                            <FullScreen ref="fullscreen" style="width: 100%; height: 100%" @fullScreenin="isFull = true"
                                @fullScreenOut="isFull = false" @dblclick.native="dblclick">
                                <VideoRTC v-if="hiveObj && defaultVideoPath(hiveObj.srsUrl, hiveObj.flvSrc, 1)"
                                    :src="defaultVideoPath(hiveObj.srsUrl, hiveObj.flvSrc, 1)"
                                    :key="defaultVideoPath(hiveObj.srsUrl, hiveObj.flvSrc, 1)" width="100%" />
                                <img v-else src="./images/Mask-air.png" />
                            </FullScreen>
                        </div>
                    </div>
                    <div class="c-hive-point__item">
                        <div class="c-hive-point__label">
                            <img class="img" src="./images/icon_air.png" />
                            无人机
                        </div>
                        <div class="c-hive-point__value">
                            {{ hiveObj.uavs && hiveObj.uavs.length > 0 ? hiveObj.uavs[0].name : '---' }}
                        </div>
                    </div>
                    <div class="c-hive-point__item">
                        <div class="c-hive-point__label">
                            <img class="img" src="./images/stack-fill.png" />
                            任务
                        </div>
                        <div class="c-hive-point__value">
                            <CustomMarquee v-if="visible" :autoScroll="true" :duration="5" deb>
                                <p>
                                    {{
                                        hiveObj.stutas === 2
                                            ? hiveObj.runTask
                                            : hiveObj.nextTask
                                                ? hiveObj.nextTask.name
                                                : '---'
                                    }}
                                </p>
                            </CustomMarquee>
                        </div>
                    </div>
                    <div class="c-hive-point__item">
                        <div class="c-hive-point__label">
                            <img class="img" src="./images/time-line.png" />
                            进度
                        </div>
                        <div class="c-hive-point__value">
                            <el-progress v-if="hiveObj.runTask" class="progress" :stroke-linecap="'butt'"
                                :stroke-width="15" :percentage="hiveObj.taskProgress * 100"></el-progress>
                            <template v-else>---</template>
                        </div>
                    </div>
                    <div class="c-hive-point__item">
                        <div class="c-hive-point__label">
                            <img class="img" src="./images/icon_battery.png" />
                            充电
                        </div>
                        <div class="c-hive-point__value">
                            <img v-if="hiveObj.chargeOn" class="value-img" src="./images/icon_battery.png" />
                            <img v-else class="value-img" src="./images/icon_battery-1.png" />
                            <!-- <img
                              v-show="battery.includes(3)"
                              class="value-img"
                              src="./images/icon_battery-2.png"
                          />
                          <img
                              v-show="battery.includes(6)"
                              class="value-img"
                              src="./images/icon_battery-3.png"
                          />
                          <img
                              v-show="battery.includes(9)"
                              class="value-img"
                              src="./images/icon_battery-4.png"
                          /> -->
                        </div>
                    </div>
                </div>
                <div class="c-hive-point__btn" @click="toDetailView(hiveObj)">{{ $t('yingji.emergencyHives.enterControl') }}</div>
            </div>
            <div slot="reference" :style="style"></div>
        </el-popover>
    </div>
</template>
<script>
import { FullScreen } from '@CommonComponent';
import { LCircleFeature, LLineFeature, OMapMixin, LOverLay, LVector, LPointFeature } from '@OpenLayersCommon';
import { StringUtil } from '@Util';
import { tool } from '@CesiumCommon';
import * as turf from '@turf/turf';
import imgs from './ol-point/imgs';
import CustomMarquee from '@/page/mainPage/components/CustomMarquee/CustomMarquee.vue';
import VideoRTC from '@/page/mainPage/components/VideoRTC.vue';

export default {
    mixins: [OMapMixin],
    name: 'op-Hivelist',
    props: {
        hives: Array,
        caseListAll: Array,
        dangerCoordinate: Object,
        changeStatiMapHives: Function,
        statiMapHives: Array,
        defaultCheckList: Array,

        clickable: {
            default: true,
        },
    },
    // Marker ,LPoints LMarker, LCircularRange,Video, FullScreen,LCircleFeature
    components: {
        LVector,
        LOverLay,
        LLineFeature,
        LPointFeature,
        LCircleFeature,
        CustomMarquee,
        FullScreen,
        VideoRTC,
    },
    data () {
        return {
            videoUrl: '', // 视频地址
            hList: [],
            imgsrc: require('./images/icon-site-2.png'),
            isFull: false,
            visible: false,
            videoId: null,
            style: {
                position: 'absolute',
                top: '100px',
                left: '100px',
            },
            hiveObj: {},
            mapZoom: 11,
            battery: [100, 75, 25, 0], // 电量模拟
            hoverFeatureId: null, // 控制鼠标移入状态

        };
    },
    watch: {
        layerAuto: {
            handler (newVal, oldVal) {
                // console.log('EmergencyHives=======>', newVal);
            },
            immediate: true,
            deep: true,
        },
        hives: {
            handler (newVal, oldVal) {
                this.hList = this.SetList(newVal, 0);
                // console.log('this.hList', this.hList);
            },
            immediate: true,
            deep: true,
        },
        statiMapHives: {
            handler (newVal, oldVal) {
                // console.log('statiMapHives========>', newVal);
                newVal.forEach((item) => {
                    // console.log('hasCheckedBox', item.hasCheckedBox);
                });
            },
            immediate: true,
            deep: true,
        },
        dangerCoordinate: {
            handler (newVal, oldVal) {
                // console.log('dangerCoordinate======>', newVal);
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        layerAuto () {
            return this.$store.state.Common.LayerAuto;
        },
    },
    filters: {
        getDistance (points) {
            let { ponit1, point2 } = points;
            let distance = +tool.distance(ponit1, point2);
            if (distance / 1000 >= 1) {
                distance = `${(distance / 1000).toFixed(1)}km`;
            } else {
                distance = `${distance}m`;
            }
            return distance;
        },
    },

    async mounted () {
        this.hList = this.SetList(this.hives, 0);

        let map = await this.getMap();
        this.map = map;
        // 更新zoom
        this.map.getView().on('change:resolution', this.changeZoom);
    },
    beforeDestroy () {
        this.map && this.map.getView().un('change:resolution', this.changeZoom);
    },
    methods: {

        checkHive (e, item) {
            this.$emit('changeStatiMapHives', e, item, true);
        },
        defaultVideoPath (p1, p2, type) {
            let res = null;
            if (p1?.includes('flv')) {
                res = p1;
            }
            if (p2?.includes('flv')) {
                res = p2;
            }
            return res;
        },
        // 双击全屏
        dblclick () {
            this.handleFullScreen();
        },
        handleFullScreen () {
            this.$refs.fullscreen.toggleFullCreeen();
        },
        // 机库样式
        hivetStyle (name, item) {
            let scale = this.getScale();
            return {
                icon: {
                    src: require(`./images/icon-site-${item.onlineState ? 2 : 1}.png`),
                    scale,
                },
                text: {
                    textAlign: 'center',
                    textBaseline: 'middle',
                    font: 'normal  14px  Microsoft YaHei-Regular, Microsoft YaHei',
                    text: this.mapZoom > 13.3 ? name : '',
                    offsetY: 50 * scale,
                    offsetX: 0,
                    fill: {
                        color: '#FFFFFF',
                    },
                    padding: [2, 5, 2, 5],
                    stroke: {
                        color: '#000',
                        width: 1,
                    },
                },
            };
        },
        getScale () {
            let scale = 1;
            let mapZoom = this.mapZoom;
            scale = (mapZoom - 13.3) * 0.2 + 0.6;
            if (scale < 0.6) scale = 0.6;
            if (scale > 1) scale = 1;
            return scale;
        },
        // 机库 label
        hiveLabel (item) {
            let statusText = '';
            let runTaskName = '';
            let nextTaskName = '';
            statusText = item.onlineState ? '在线' : '离线'; // this.getStauts(item.status);
            if (item.runTask) {
                runTaskName = `| ${item.runTask.name}`;
            }
            if (item.nextTask) {
                nextTaskName = ` | ${item.nextTask.name}`;
            }
            let text = `${statusText} ${runTaskName}${nextTaskName}`;

            return text;
        },
        // label 样式
        hiveLabelStyle (item) {
            let scale = this.getScale();

            // 跟随机库图标缩放比例去调整label 到机库的距离
            const siteIconHeight = 72; // 机库图标原始高度
            let offsetY = 0;
            if (scale < 1) {
                offsetY = siteIconHeight / 2 - (scale * siteIconHeight) / 2;
            }

            let status = item.onlineState ? 2 : 1;

            const Colors = {
                1: {
                    borderColor: '#C2C2C2',
                    background: 'rgba(11,17,23,0.6)',
                },
                2: {
                    borderColor: '#49F0FD',
                    background: 'rgba(11,17,23,0.6)',
                },
                3: {
                    borderColor: '#FFED59',
                    background: 'rgba(11,17,23,0.6)',
                },
                4: {
                    borderColor: '#FF515B',
                    background: 'rgba(71,14,17,0.6)',
                },
            };
            const fontSize = 12;
            const ColorMap = Colors[status];
            let labelText = this.hiveLabel(item);
            const maxLen = 14; // 显示最大长度
            let width = 0;
            if (labelText.length > maxLen) {
                width = fontSize * 14;
            } else {
                width = fontSize * labelText.length * 2;
            }

            let obj = {
                height: '22px',
                width: `${width}px`,
                lineHeight: '22px',
                textAlign: 'center',
                fontSize: `${fontSize}px`,
                padding: '0px 10px',
                boxShadow: `inset 0px 1px 9px 0px ${ColorMap.borderColor}`,
                background: ColorMap.background,
                borderRadius: '15px',
                border: `1px solid ${ColorMap.borderColor}`,
                transform: `translateY(${offsetY}px)`,
            };
            let mapZoom = this.mapZoom;
            if (mapZoom <= 13.3) {
                obj.opacity = 0;
            }
            return obj;
        },
        // 机库头部
        topStyle (item) {
            return null;
        },

        // 机库范围
        getRenderer (item, active) {
            return (coordinates, state) => {
                const [[x, y], [x1, y1]] = coordinates;
                const ctx = state.context;
                const dx = x1 - x;
                const dy = y1 - y;
                const radius = Math.sqrt(dx * dx + dy * dy);

                const innerRadius = 0;
                const outerRadius = radius * 1.4;

                const gradient = ctx.createRadialGradient(x, y, innerRadius, x, y, outerRadius);
                if (active) {
                    gradient.addColorStop(
                        0,
                        item.factory.includes('dji') ? 'rgba(240,222,55,0.5)' : 'rgba(73,240,253,0.5)',
                    );
                    gradient.addColorStop(
                        1,
                        item.factory.includes('dji') ? 'rgba(240,222,55,0.5)' : 'rgba(73,240,253,0.5)',
                    );
                } else {
                    gradient.addColorStop(
                        0,
                        item.factory.includes('dji') ? 'rgba(240,222,55,0.18)' : 'rgba(73,240,253,0.18)',
                    );
                    gradient.addColorStop(
                        1,
                        item.factory.includes('dji') ? 'rgba(240,222,55,0.18)' : 'rgba(73,240,253,0.18)',
                    );
                }
                ctx.strokeStyle = item.factory.includes('dji') ? 'rgba(240,222,55,.5)' : 'rgba(73,240,253,.5)';
                ctx.beginPath();
                ctx.arc(x, y, radius, 0, 2 * Math.PI, true);
                ctx.fillStyle = gradient;
                ctx.fill();
                ctx.arc(x, y, radius, 0, 2 * Math.PI, true);
                ctx.stroke();
            };
        },

        // 整理机库数组
        SetList (list) {
            let result = [];
            list.forEach((item) => {
                let val = {
                    ...item,
                    imgsrc: imgs[`site_${item.onlineState ? 2 : 1}`],
                    timgsrc: imgs[`bg_site_${item.onlineState ? 2 : 1}`],
                    longitude: Number(item.longitude),
                    latitude: Number(item.latitude),
                    speed: 0,
                    factory: item.model || null,
                };
                result.push(val);
            });
            return result;
        },
        // 跳转2级界面
        toDetailView (hiveObj) {
            // this.$refs.fullscreen.toggleFullCreeen();
            // console.log(hiveObj);
            if (hiveObj.hives && hiveObj.hives.length > 0) {
                let hive = hiveObj.hives[0];
                let hiveCode = hive.code;
                this.$router.push({
                    path: 'console',
                    query: {
                        type: 2,
                        hiveCode,
                    },
                });
            } else {
                this.$message(this.$t('yingji.emergencyHives.noHivesAtSite'));
            }
            this.visible = false;
        },
        hoverFeature (e, id, feature, obj) {
            if (obj) {
                this.hoverFeatureId = id;
            } else {
                this.hoverFeatureId = null;
            }
        },
        // 弹窗位置
        select (e, id, feature, obj) {
            if (!this.$props.clickable) return;
            // if (id.indexOf('_point') !== -1) {
            //     this.visible = true;
            //     let [x, y] = e.pixel_;
            //     this.style.top = `${y - 10}px`;
            //     this.style.left = `${x}px`;
            //     this.hiveObj = obj;
            //     // 获取视频地址
            //     if (this.hiveObj.pullUrl !== '') {
            //         this.videoUrl = this.hiveObj.pullUrl;
            //     }
            //     setTimeout(() => {
            //         this.showPopover(id);
            //     }, 50);
            // }
        },
        // 显示弹窗
        showPopover (id) {
            this.videoId = id;
            this.visible = false;
            this.$nextTick(() => {
                this.visible = true;
            });
        },
        // 匹配状态
        getStauts (num) {
            let status = '';
            switch (num) {
                case 0:
                    // eslint-disable-next-line no-unused-expressions
                    status = this.$t('yingji.emergencyHives.offline');
                    break;
                case 1:
                    // eslint-disable-next-line no-unused-expressions
                    status = this.$t('yingji.emergencyHives.online');
                    break;
                case 2:
                    // eslint-disable-next-line no-unused-expressions
                    status = this.$t('yingji.emergencyHives.taskExecuting');
                    break;
                case 3:
                    // eslint-disable-next-line no-unused-expressions
                    status = this.$t('yingji.emergencyHives.abnormal');
                    break;
                default:
                    // eslint-disable-next-line no-unused-expressions
                    status = this.$t('yingji.emergencyHives.offline');
            }
            return status;
        },
        changeZoom (evt) {
            const zoom = this.map.getView().getZoom(); // 获取当前地图的缩放级别
            this.mapZoom = zoom;
        },
    },
};
</script>
<style lang="scss">
.command-overlayer-hives-checkbox {
    z-index: 3;
}

.command-overlayer-hives-km {
    z-index: 4;
}
</style>
<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

::v-deep .el-checkbox__inner {
    width: 16px;
    height: 16px;
    background: transparent;
    border: 2px solid #49f0fd;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background: #49f0fd;
    border-color: #49f0fd;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #49f0fd;
}

::v-deep .el-checkbox__inner::after {
    left: 4px;
    top: 1px;
    border-color: #000;
}

.point-distance {
    font-size: 14px;
    color: #fff;
    // width: 37px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: rgba(7, 17, 80, 0.7);
    box-shadow: inset 0px 1px 12px 0px rgba(26, 71, 164, 0.65);
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #49f0fd;
    padding: 0 5px;
}

.point-distance-active {
    height: 22px;
    line-height: 22px;
    padding: 0 5px;
    text-align: center;
    font-size: 14px;
    color: #10163a;
    background: linear-gradient(90deg, #ff8b00 0%, rgba(255, 214, 0, 0.94) 100%);
    border-radius: 2px 2px 2px 2px;
    border: 1px solid rgba(7, 17, 80, 0.7);
}

@include b(hive-point, c) {
    @include e(popover) {
        position: relative;
        width: 298px;
        padding: 16px;
        box-sizing: border-box;

        &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -2;
            position: absolute;
            top: -0px;
            left: 0px;
            background-color: #071150;
        }

        &::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -1;
            position: absolute;
            top: 0px;
            left: 0px;
            border: 24px solid;
            box-sizing: border-box;
            border-image: url(./images/bg_wrap.png) 24 24;
        }

        @include e(header) {
            display: inline-block;
            text-align: center;
            width: 100%;
            height: 30px;
            background-color: rgba(255, 226, 184, 0.2);
            border-radius: 3px;
            outline: thick double rgba(255, 226, 184, 0.2);
            line-height: 30px;
            font-weight: 400;
            color: #ffe600;
            font-size: 16px;
        }

        @include e(main) {
            width: 260px;
            color: white;

            @include e(video) {
                height: 140px;
                margin: 10px 0px 16px 0px;
            }

            @include e(item) {
                display: flex;
                margin-bottom: 8px;

                @include e(label) {
                    width: 74px;
                    height: 26px;
                    padding: 2px;
                    background: linear-gradient(91deg, #50f5ff 0%, rgba(80, 245, 255, 0) 100%);
                    vertical-align: middle;
                    line-height: 26px;

                    .img {
                        width: 20px;
                        height: 20px;
                        vertical-align: middle;
                    }
                }

                @include e(value) {
                    margin-left: 16px;
                    padding: 2px;
                    display: flex;
                    width: calc(100% - 74px - 16px);
                    overflow: hidden;

                    // width: 180px;
                    .progress {
                        width: 150px;

                        &::v-deep .el-progress__text {
                            font-size: 16px !important;
                            color: white !important;
                        }
                    }

                    .value-img {
                        width: 20px;
                        height: 26px;
                    }

                    ::v-deep.el-progress-bar__outer,
                    ::v-deep.el-progress-bar__inner {
                        border-radius: 0;
                    }

                    ::v-deep.el-progress-bar__inner {
                        background: linear-gradient(270deg, #36eaaf 0%, #4bb3d2 100%);
                    }

                    ::v-deep.el-progress-bar__outer {
                        background: rgba(255, 255, 255, 0.1);
                    }
                }
            }
        }

        @include e(btn) {
            width: 100%;
            height: 37px;
            line-height: 37px;
            background: rgba(73, 240, 253, 0.2);
            border: 1px solid #49f0fd;
            display: inline-block;
            font-weight: 400;
            color: #49f0fd;
            font-size: 16px;
            margin-top: 15px;
            cursor: pointer;
            text-align: center;
        }
    }
}
</style>
